
import React from 'react';
import { Card } from '@/components/ui/card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';

const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#F97316'];

const PerformanceCharts = ({ analytics }: { analytics: any }) => (
  <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mt-6">
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Monthly Real Plays</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={analytics?.monthlyData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line 
            type="monotone" 
            dataKey="real_plays" 
            stroke="#10B981" 
            strokeWidth={2} 
            name="Real Plays"
          />
        </LineChart>
      </ResponsiveContainer>
    </Card>

    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Games by Category (All-Time)</h3>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={analytics?.categoryStats}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, value }: any) => `${name}: ${value}`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="games"
            nameKey="name"
          >
            {analytics?.categoryStats?.map((entry: any, index: number) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value, name) => [value, name]} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Card>
  </div>
);

export default PerformanceCharts;
